module.exports = __webpack_public_path__ + "img/Lqdelete.95b9a6be.svg";